 
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
//qyfnoh-hAztuf-9dobje
// NOTE: Modified to support Email OTP passwordless authentication
const awsmobile = {
    Auth:{
        Cognito: {
            region: "us-east-2",
            userPoolId: "us-east-2_PCYxQpkSB",
            userPoolClientId: "2jfboguf872voqsvks2gbl9sug",
            authenticationFlowType: "USER_AUTH"
        }
    }
};


export default awsmobile;
